export default "__VITE_ASSET__lNWyZ5Jm__"